










































































import { Component, Mixins } from 'vue-property-decorator';
import { Actions, Mutations } from '@/ts/store/Constants';
import { mapGetters } from 'vuex';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';
import SelectedItems from '@/components/Admin/Layout/SelectedItems.vue';

@Component({
    components: {
        SelectedItems,
    },
    computed: {
        ...mapGetters({
            currentEditRole: 'RolesAndPermissions/getCurrentEditRole',
        }),
    },
})
export default class AddRoleForm extends Mixins(InputFieldMethods) {
    constructor() {
        super();
    }

    public editRole() {
        this.$validator.validate().then((valid) => {
            if (valid) {
                const currentRole = this.$store.getters['RolesAndPermissions/getCurrentEditRole'];

                this.$store.dispatch(Actions.EDIT_CURRENT_ROLE, {
                    id: currentRole.id,
                    name: currentRole.name,
                    description: currentRole.description,
                    staff: currentRole.isStaff ? true : false,
                    visible: currentRole.visible ? true : false,
                });
            }
        });
    }

    public beforeDestroy() {
        this.$store.commit(Mutations.SET_CURRENT_EDIT_ROLE, []);
    }

    public cancel() {
        this.$store.dispatch(Actions.HIDE_FORM);
        this.$store.commit(Mutations.SET_CURRENT_EDIT_ROLE, []);
    }
}
